import React, { FC } from "react";
import { FaqAccordion } from "../components/FaqAccordion";
import { makeStyles, Box } from "@material-ui/core";
import { Text } from "../components/Text";

const Faq: FC = () => {
  const classes = styles();
  return (
    <Box className={classes.container}>
      <Box maxWidth={1000}>
        <Box width={1}>
          <Text variant="h6" gutterBottom bold>
            FAQ
          </Text>
        </Box>
        <FaqAccordion />
      </Box>
    </Box>
  );
};

const styles = makeStyles(() => ({
  container: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
}));

export default Faq;
